import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Tooltip from 'tooltip.js';
import { connect } from 'react-redux';
import _get from 'lodash/get';

const mapStateToProps = (state) => {
	const isMobile = _get(state, 'application.isMobile');
	return {
		isMobile: isMobile
	};
}

class TooltipTarget extends Component {
	static propTypes = {
		content: PropTypes.string,
		id: PropTypes.string,
		placement: PropTypes.string,
		isMobile: PropTypes.bool
	}
  
	componentDidMount() {
		const isMobile = this.props.isMobile;
		var reference = document.getElementById(this.props.id);
		var tooltip = new Tooltip(reference, {   // eslint-disable-line
			title: this.props.content,
			trigger: `${isMobile ? 'click' : 'hover' }`,
			placement: this.props.placement,
			closeOnClickOutside: true,
			html: true
		});  
	}
  
	render() {
		return (
			<span className="icon icon-tooltip-small" 
				id={this.props.id}
				style={{ fontSize: 'x-large', color: '#005ea6' }}
			>
			</span>
		);
	}
}
export default connect(mapStateToProps)(TooltipTarget);



// WEBPACK FOOTER //
// ./buttons/components/tooltip/TooltipTarget.js